<mat-nav-list>
  <app-menu-list-item *ngFor="let item of navItems" [item]="item" [depth]="0" parentPath=""></app-menu-list-item>
</mat-nav-list>
